module.exports = __webpack_public_path__ + "img/h-banner12.f44a1d2c.jpg";